import styled from 'styled-components'
import { mobileL, mobileS } from '../../../../../../utils/mediaQueries'

// eslint-disable-next-line import/prefer-default-export
export const SearchStatusWrapper = styled.div`
  width: 100%;

  .research-status-group {
    display: flex;
    gap: 55px;
    justify-content: center;

    ${mobileL({
      flexDirection: 'row',
      gap: '15px',
      justifyContent: 'space-between',
    })}

    ${mobileS({
      flexDirection: 'column',
      gap: '15px',
      justifyContent: 'center',
      alignItems: 'center',
    })}
  }

  .ant-radio-button-wrapper {
    width: 150px;
    height: 150px !important;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0px !important;
    transition-duration: 500ms;

    ${mobileL({
      width: '130px',
      height: '130px !important',
      fontSize: '11px',
    })}
  }

  .ant-radio-button-wrapper:hover {
    color: unset;
    background-color: var(--border-light);

    .border-icons {
      background-color: #fff;
    }
  }
  span:not(.ant-radio-button) {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }

  .border-icons {
    width: 70px;
    height: 70px;
    padding: 15px;
    border-radius: 50%;
    background-color: var(--border-light);
    transition: ease 500ms all;
  }
`
